import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../services/global.service';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.css']
})
export class PreloaderComponent implements OnInit {

  subscription;
  // src = '/dist/assets/preloader.svg';
  src = '/dist/assets/giphy.gif';
  preloaderVisible: boolean = false;

  constructor ( private global: GlobalService ) { 
  }

  ngOnInit ( ) { 
    this.subscription = this.global.showPreloader( )
      .subscribe( item => { this.preloaderVisible = item; });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/preloader/preloader.component.ts